"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedUsageForFuel = exports.dataOutsideSupply = exports.formatRowDateForPeriod = exports.formatColDateForPeriod = void 0;
var date_fns_1 = require("date-fns");
var utils_1 = require("../../utils");
var formatColDateForPeriod = function (date, datePeriod) {
    switch (datePeriod) {
        case 'yearly':
            return (0, date_fns_1.format)(date, 'yyyy');
        case 'monthly':
            return (0, date_fns_1.format)(date, 'MMM yyyy');
        default:
            return (0, date_fns_1.format)(date, 'd MMM');
    }
};
exports.formatColDateForPeriod = formatColDateForPeriod;
var formatRowDateForPeriod = function (date, datePeriod, isComparing) {
    switch (datePeriod) {
        case 'yearly':
            return isComparing ? (0, date_fns_1.format)(date, 'MMM') : (0, date_fns_1.format)(date, 'MMM yyyy');
        case 'monthly':
            return isComparing ? (0, date_fns_1.format)(date, 'd') : (0, date_fns_1.format)(date, 'd MMM yyyy');
        default:
            return (0, date_fns_1.format)(date, 'h:mmaaa');
    }
};
exports.formatRowDateForPeriod = formatRowDateForPeriod;
var dataOutsideSupply = function (date, fuel, supplyInfo, datePeriod) {
    switch (fuel) {
        case 'both':
            var earliestStart = (0, utils_1.getEarliestSupplyStartDate)(supplyInfo);
            return (!date ||
                !earliestStart ||
                (0, date_fns_1.isFuture)(date) ||
                (0, date_fns_1.isBefore)(date, datePeriod === 'yearly' ? (0, date_fns_1.startOfMonth)(earliestStart) : earliestStart));
        case 'electricity':
            var elecStart = supplyInfo.electricity && supplyInfo.electricity.start;
            return (!date ||
                !elecStart ||
                (0, date_fns_1.isFuture)(date) ||
                (0, date_fns_1.isBefore)(date, datePeriod === 'yearly' ? (0, date_fns_1.startOfMonth)(elecStart) : elecStart));
        case 'gas':
            var gasStart = supplyInfo.gas && supplyInfo.gas.start;
            return (!date ||
                !gasStart ||
                (0, date_fns_1.isFuture)(date) ||
                (0, date_fns_1.isBefore)(date, datePeriod === 'yearly' ? (0, date_fns_1.startOfMonth)(gasStart) : gasStart));
    }
};
exports.dataOutsideSupply = dataOutsideSupply;
var formattedUsageForFuel = function (data, fuel, unit) {
    var formatter = unit === 'kwh' ? utils_1.formatKwh : utils_1.formatCost;
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    switch (fuel) {
        case 'gas':
            return formatter(data.gas ? data.gas[unitProp] : null);
        case 'electricity':
            return formatter(data.electricity ? data.electricity[unitProp] : null);
        case 'both':
            var gasUsage = data.gas && data.gas[unitProp];
            var elecUsage = data.electricity && data.electricity[unitProp];
            if (gasUsage !== null && elecUsage !== null) {
                return formatter(gasUsage + elecUsage);
            }
            return formatter(gasUsage !== null ? gasUsage : elecUsage);
    }
};
exports.formattedUsageForFuel = formattedUsageForFuel;
